import * as _ from 'lodash';
import  DataContext  from '../common/data/dataContext.service';
import { VoziqOfferFlow } from '../common/voziq/voziqOfferFlow.service';

export class MyAccountController {
    public alertName = 'account_alert';

    private paymentSummary: any;
    private pendingPayments: any[];

    constructor(
        private $q: ng.IQService,
        private dataContext: DataContext,
        private alertService: any,
        private constants: any,
        private voziqOfferFlow: VoziqOfferFlow) {
        'ngInject';
    }

    public $onInit() {
        this.getPaymentInfo()
            .then((result) => {
                this.paymentSummary = result.paymentSummary;
                this.pendingPayments = result.pendingPayments;

                if (_.get(this.constants, 'alerts.pastDuePayment.enabled', true)) {
                    this.showPastDuePaymentReminder();
                }
            });
        this.voziqOfferFlow.autoOpen('account');
    }

    private getPaymentInfo() {
        return this.$q.all([
            this.dataContext.payment.getPaymentSummary(),
            this.dataContext.payment.getPendingPayments()
        ]).then((results: any[]) => {
            const paymentSummary = results[0].PaymentSummaryInfo;
            const pendingPayments = results[1];

            return {
                paymentSummary,
                pendingPayments
            };
        });
    }

    private showPastDuePaymentReminder() {
        const hasOverdueBalance =
            !_.isNil(this.paymentSummary) &&
                this.paymentSummary.HasAccountPastDue &&
                this.paymentSummary.AccountPastDue > 0;
        const hasPendingPayments = !_.isEmpty(this.pendingPayments);
        const showReminder = hasOverdueBalance && !hasPendingPayments;

        if (showReminder) {
            this.alertService
                .get(this.alertName)
                .setMessage(
                    '<div id="past-due-reminder">' +
                        '<div class="text-uppercase text-bold">Past Due Reminder</div>' +
                        '<p>We have been unable to process your recurring monthly payment. Please ' +
                            '<a ui-sref="account.settings.billing">update your payment information</a>.' +
                        '</p>' +
                    '</div>'
                )
                .setType('danger')
                .open();
        }
    }
}

export const myaccountComponent = {
    controller: MyAccountController,
    template: require('./myaccount.html')
};